<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Role Permissions</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <span class="ml-12 p-2">Role: </span>
          <v-select label='role' class="filter ml-2" v-model="selected_role" :options="roles" />
        </vs-col>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">

        </vs-col>
      </vs-row>

      <vs-table class="mb-10" @search="handleSearch" @sort="handleSort" v-model="selected" stripe :data="resources">
        <template slot="thead">
          <vs-th>Resource</vs-th>
          <vs-th>Create</vs-th>
          <vs-th>Read</vs-th>
          <vs-th>Update</vs-th>
          <vs-th>Delete</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].resourceName">
              {{ data[indextr].resourceName }}
            </vs-td>
            <vs-td v-if="data[indextr].create == false || data[indextr].create == true">
              <vs-checkbox v-model="data[indextr].create"></vs-checkbox>
            </vs-td>
            <vs-td v-if="data[indextr].read == false || data[indextr].read == true">
              <vs-checkbox v-model="data[indextr].read"></vs-checkbox> 
            </vs-td>
            <vs-td v-if="data[indextr].update == false || data[indextr].update == true">
              <vs-checkbox v-model="data[indextr].update"></vs-checkbox>
            </vs-td>
            <vs-td v-if="data[indextr].delete == false || data[indextr].delete == true">
              <vs-checkbox v-model="data[indextr].delete"></vs-checkbox>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="4" vs-xs="12">
        <vs-button @click.prevent="submitForm" class="mb-10" color="primary" type="filled">Submit</vs-button>
      </vs-col>

    </vx-card>
  </div>
</template>
<script>
import defineAbilitiesFor from '@/config/abilities'

import moduleRoleManagement from "@/store/role-management/moduleRoleManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    abilities: null,
    // resources:[
    // {"resourceName" : "Roles","create":true,"read":true,"update":true,"delete":true,"name":"roles"},
    // {"resourceName" : "Elomark User Types","create":true,"read":true,"update":true,"delete":true,"name":"user-types"},
    // {"resourceName" : "Elomark Users","create":true,"read":true,"update":true,"delete":true,"name":"elomark-users"},
    // {"resourceName" : "Clients","create":true,"read":true,"update":true,"delete":true,"name":"clients"},
    // {"resourceName" : "Client Users","create":true,"read":true,"update":true,"delete":true,"name":"client-users"},
    // {"resourceName" : "Client Email","create":true,"read":true,"update":true,"delete":true,"name":"client-email"},
    // {"resourceName" : "Accounts","create":true,"read":true,"update":true,"delete":true,"name":"accounts"},
    // {"resourceName" : "Contacts","create":true,"read":true,"update":true,"delete":true,"name":"contacts"},
    // {"resourceName" : "Campaigns","create":true,"read":true,"update":true,"delete":true,"name":"campaigns"},
    // {"resourceName" : "Master Fields","create":true,"read":true,"update":true,"delete":true,"name":"master-fields"},
    // {"resourceName" : "Client Fields","create":true,"read":true,"update":true,"delete":true,"name":"client-fields"},
    // {"resourceName" : "Campaign Fields","create":true,"read":true,"update":true,"delete":true,"name":"campaign-fields"},
    // {"resourceName" : "Field Values","read":true,"name":"field-values"},
    // {"resourceName" : "Import Account/Contact To Campaign","read":true,"name":"import-account-contact-to-campaign"},
    // {"resourceName" : "Select Campaign Fields","read":true,"name":"select-campaign-fields"},
    // {"resourceName" : "Populate Sales Developer Data","read":true,"name":"populate-data"},
    // {"resourceName" : "Assign Sales Developer Data","read":true,"name":"assign-data"},
    // {"resourceName" : "Import Accounts/Contacts Directly To Database","read":true,"name":"import-accounts-contacts-directly-to-database"},
    // {"resourceName" : "Unmatched Accounts","read":true,"name":"unmatched-accounts-contacts"},
    // {"resourceName" : "Master Steps","create":true,"read":true,"update":true,"delete":true,"name":"master-steps"},
    // {"resourceName" : "Client Steps","create":true,"read":true,"update":true,"delete":true,"name":"client-steps"},
    // {"resourceName" : "Setup Campaigns Steps","read":true,"name":"campaign-steps"},
    // {"resourceName" : "Cascading Fields","read":true,"name":"cascading-fields"},
    // {"resourceName" : "Campaign Grade","create":true,"read":true,"update":true,"delete":true,"name":"grade"},
    // {"resourceName" : "Grade Steps","create":true,"read":true,"update":true,"delete":true,"name":"grade-steps"},
    // {"resourceName" : "Clone Grade","read":true,"name":"clone-grade"},
    // {"resourceName" : "Categorize Grades","create":true,"read":true,"update":true,"delete":true,"name":"categorize-grades"},
    // {"resourceName" : "Client User View","read":true,"name":"client-user-view"},
    // {"resourceName" : "Docs Template","create":true,"read":true,"update":true,"delete":true,"name":"docs-template"},
    // {"resourceName" : "Email Template","create":true,"read":true,"update":true,"delete":true,"name":"email-template"},
    // {"resourceName" : "Send Opportunity Alert","read":true,"name":"send-opportunity-alerts"},
    // {"resourceName" : "Action Type","create":true,"read":true,"update":true,"delete":true,"name":"action-type"},
    // {"resourceName" : "Outcome","create":true,"read":true,"update":true,"delete":true,"name":"outcome"},
    // {"resourceName" : "Dial Action","read":true,"name":"dial-action"},
    //   {"resourceName" : "Submit Hours","read":true,"name":"submit-hours"},
    //  {"resourceName" : "Quality Control","read":true,"name":"quality-control"},
    //    {"resourceName" : "Calendar","read":true,"name":"calendar"}
    // ],
    resources: [],
    roles: [],
    selected_role: { role: 'Global Administrator', id: "c77c864d-0ef0-482e-a62a-45b0030f6cbb" },
    selected: [],

  }),
  components: {
    "v-select": vSelect,
  },
  watch: {
    selected_role: function (val) {
      let self = this
      this.roles.forEach(element => {
        if (element.role == val.role) {
          self.resources = element.role_permission
        }
      });
    },
  },
  methods: {
    submitForm() {
      this.$vs.loading();

      let role_with_permission = {}
      role_with_permission.role_permission = this.resources
      role_with_permission.id = this.selected_role.id
      this.$store
        .dispatch("rolesManagement/updateRolePermission", role_with_permission)
        .then(res => {

          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Something went wrong",
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Role Permission",
              text: "The role permission has been updated successfully"
            });
          }

          this.$vs.loading.close();



        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    handleSearch(searching) {
      console.log(`The role searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the role ordered: ${key} ${active}`);
    },
    fetchRoles() {
      this.$store
        .dispatch(
          "rolesManagement/fetchRoles")
        .then(res => {
          this.roles =
            moduleRoleManagement.state.roles;
          var self = this
          this.roles.forEach(element => {
            if (element.role == 'Global Administrator') {
              self.resources = element.role_permission
            }
          });
          console.log(self.resources)
        })
        .catch(err => {
          console.log(err);
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  },
  mounted() {
    this.fetchRoles();
  },
  created() {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    });
    if (!moduleRoleManagement.isRegistered) {
      this.$store.registerModule(
        "rolesManagement",
        moduleRoleManagement
      );
      moduleRoleManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}


.address_td {
  padding: 30px;
  font-weight: 500;
}

.vs-con-table .vs-con-tbody .con-vs-checkbox {
  justify-content: normal !important;
}
</style>

<style lang="stylus">
.con-expand-roles
  .con-btns-role
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-rolex
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
